import React, { useState } from "react";
import {
  useNavigate,
  useLocation,
  useParams,
} from "react-router-dom";
import "./style/VillaCard.css";
import { BASE_URL_IMG } from "../../api/apiConfig";
import DetailsUnit from "./detailsUnit";
import Button from "../button/button";
import Floors from "./floors";
import ar from "../../lang/ar";
import en from "../../lang/en";

function VillaCard({
  onUnitClick,
  zoneId,
  page,
  width,
  villa,
  onShowProgress,
  onOpenModal,
  isMobile,
  setCurrentFloor,
  lang,
  floorsData,
  currentFloor,
}) {
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { projectSlug, zoneId: paramZoneId } = useParams(); 

  if (!villa) return null;

  const isInteractiveTour = location.pathname.includes("/tour/");
  const isExploreTour = location.pathname.includes("/villa/") && !location.pathname.includes("/tour/");
  const isMasterPlanPage = location.pathname.includes("master-plan") && !location.pathname.includes("/villa/");

  // ✅ تعديل وظيفة الـ Explore لتدعم الـ Slug
  const handleExplore = () => {
    if (villa && villa.code && projectSlug) {
      const currentZoneId = zoneId || paramZoneId;
      if (currentZoneId) {
        navigate(`/${projectSlug}/master-plan/${currentZoneId}/villa/${villa.code}`);
      } else {
        // حالة احتياطية إذا لم يوجد zoneId
        navigate(`/${projectSlug}/master-plan/villa/${villa.code}`);
      }
    }
  };

  // ✅ تعديل وظيفة الـ Interactive لتدعم الـ Slug
  const handleInteractiveNavigate = () => {
    const currentZoneId = zoneId || paramZoneId;
    const unitCode = villa.code;

    if (projectSlug && currentZoneId && unitCode) {
      navigate(
        `/${projectSlug}/master-plan/${currentZoneId}/villa/${unitCode}/tour/index.html`,
        { state: { villa } }
      );
    }
  };

  // ✅ دالة الرجوع للمخطط (Back To Master Plan)
  const handleBackToMasterPlan = () => {
    if (projectSlug) {
      const currentZoneId = zoneId || paramZoneId;
      navigate(currentZoneId ? `/${projectSlug}/master-plan/${currentZoneId}` : `/${projectSlug}/master-plan`);
    }
  };

  const translations = lang === "ar" ? ar : en;

  const handleImageClick = (e) => {
    e.stopPropagation();
    if (onUnitClick && villa.code) {
      onUnitClick(villa.code);
    }
  };

  return (
    <div
      className={`base-card-unit- ${isMobile ? "mobile" : "desktop"} ${isInteractiveTour ? "tour-mode-card" : ""}`}
      style={{ width }}
      onClick={(e) => e.stopPropagation()}
    >
      {isMobile ? (
        <div className="card-mobile-explore w-100">
          {isExploreTour && (
            <div className="btns-card">
              <div className="btns-card-inner">
                <Button
                  text="Interactive Tour"
                  className="main-btn"
                  onClick={handleInteractiveNavigate}
                />
                <Button text="spin 360" className="main-btn" />
              </div>
              <Button
                text="Back To Master Plan"
                className="backToMasterPlan-explore"
                onClick={handleBackToMasterPlan}
              />
              <Button
                text="CallBack"
                className="callBack"
                onClick={onOpenModal}
              />
            </div>
          )}

          <div className="card card-body-explore p-0">
            <div className="card-body" style={{ zIndex: 2, justifyContent: isMobile ? "start" : "space-between" }}>
              <div className="content-body">
                <p className="card-title title-unit">{villa.code || "_"}</p>
                {!isMasterPlanPage && (
                  <div className="unit-type my-2">
                    <p className="m-0">{villa.type?.name || "_"}</p>
                  </div>
                )}
                <DetailsUnit page={page} villa={villa} isMobile={isMobile} lang={lang} />
              </div>
            </div>

            <div className="card p-0" onClick={handleImageClick} style={{ cursor: "pointer" }}>
              <img src={`${BASE_URL_IMG}/${villa.type.image}`} className="card-img-top" alt="Unit" style={{ height: "140px" }} />
              <div className="card-img-overlay">
                <p className="card-title" style={{ color: villa.availability?.color || "#000" }}>
                  <span className="dot" style={{ backgroundColor: villa.availability?.color || "" }}></span>
                  {villa.availability?.name || "N/A"}
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        /* Desktop Version */
        <div className="accordion w-100" id="accordionExample">
          <div className="accordion-item">
            {isOpen && (
              <div className="accordion-body">
                <div className="card">
                  <div className="img-unit" onClick={handleImageClick} style={{ cursor: "pointer" }}>
                    <div className="card-">
                      <img src={`${BASE_URL_IMG}/${villa.type.image}`} className="card-img-top" alt="Unit" style={{ height: "140px" }} />
                      <div className="card-img-overlay">
                        <p className="card-title" style={{ color: villa.availability?.color || "#000" }}>
                          <span className="dot" style={{ backgroundColor: villa.availability?.color || "" }}></span>
                          {villa.availability?.name || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="card-body" style={{ zIndex: 2, justifyContent: isMobile ? "start" : "space-between" }}>
                    <div className="content-body">
                      <p className="card-title title-unit">{villa.code || "_"}</p>
                      {!isMasterPlanPage && (
                        <div className="unit-type my-2">
                          <p className="m-0">{villa.type?.name || "غير محدد"}</p>
                        </div>
                      )}
                      <DetailsUnit lang={lang} page={page} villa={villa} isMobile={isMobile} />
                      {!isMasterPlanPage && !isInteractiveTour && (
                        <Floors floorsData={floorsData} currentFloor={currentFloor} onFloorSelect={(floor) => setCurrentFloor(floor)} />
                      )}
                    </div>

                    {isMasterPlanPage && (
                      <div className="btns-card">
                        <div className="btns-card-inner">
                          <Button
                            text={lang === "en" ? "Explore Unit" : "استكشف المخطط"}
                            className="main-btn"
                            onClick={handleExplore} // ✅ تم التعديل
                          />
                          <Button
                            text={lang === "en" ? "Interactive Tour" : "جولة تفاعلية"}
                            className="main-btn"
                            onClick={handleInteractiveNavigate} // ✅ تم التعديل
                          />
                          <Button
                            text={lang === "en" ? "Progress" : "نسبة الإنجاز"}
                            className="main-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              onShowProgress && onShowProgress(villa);
                            }}
                          />
                        </div>
                        <Button text={lang === "en" ? "360 Spin" : "دوران 360"} className="spin" onClick={onOpenModal} />
                      </div>
                    )}

                    {isInteractiveTour && (
                      <div className="btns-card">
                        <div className="btns-card-inner">
                          <Button text="Back To Master Plan" className="main-btn" onClick={handleBackToMasterPlan} />
                          <Button text={lang === "en" ? "360 Spin" : "دوران 360"} className="spin" />
                        </div>
                        <Button text="CallBack" className="callBack" onClick={onOpenModal} />
                      </div>
                    )}

                    {isExploreTour && (
                      <div className="btns-card">
                        <div className="btns-card-inner">
                          <Button
                            text={lang === "en" ? "Interactive Tour" : "جولة تفاعلية"}
                            className="main-btn"
                            onClick={handleInteractiveNavigate} // ✅ تم التعديل
                          />
                          <Button text={lang === "en" ? "360 Spin" : "دوران 360"} className="main-btn" />
                        </div>
                        <Button
                          text="Back To Master Plan"
                          className="backToMasterPlan-explore"
                          onClick={handleBackToMasterPlan} // ✅ تم التعديل
                        />
                        <Button text={lang === "en" ? "CallBack" : "اتصل بنا"} className="callBack" onClick={onOpenModal} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default VillaCard;